// @flow

import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import classNames from 'classnames'
import { Container } from '../../../components/basic/Grid'
import messages from './fcseSpirit.lang'
import baseStyles from './fcseSpirit.scss'

/* eslint-disable max-len */
const imageLarge = (
  <StaticImage
    src="../../../images/vacancies/vacancy-spirit-large.jpg"
    alt=""
    objectFit="cover"
    className="imageCover"
  />
)
const imageSmall1 = (
  <StaticImage
    src="../../../images/vacancies/vacancy-spirit-small-1.jpg"
    alt=""
    objectFit="cover"
    className="imageCover"
  />
)
const imageSmall2 = (
  <StaticImage
    src="../../../images/vacancies/vacancy-spirit-small-2.jpg"
    alt=""
    objectFit="cover"
    className="imageCover"
  />
)
/* eslint-enable max-len */

type Props = {
  ...StyleProps
}

const fcseSpirit = ({ styles }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.root}>
      <Container className={styles.container} fluid>
        <div className={styles.spiritContent}>
          <h2 className={styles.title}>{formatMessage(messages.title)}</h2>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.lastFourth, 'icon-infinity')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item1)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.firstThird, 'icon-quality')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item2)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.firstThird, 'icon-idea')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item3)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.firstThird, 'icon-user-group')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item4)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.secondThird, 'icon-communicate')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item5)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.secondThird, 'icon-strong')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item6)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.secondThird, 'icon-strategy')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item7)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.lastThird, 'icon-relationship')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item8)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.lastThird, 'icon-development-head')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item9)}</span>
            </li>
            <li className={styles.listItem}>
              <span className={classNames(styles.icon, styles.lastThird, 'icon-passion')} />
              <span className={styles.listItemTitle}>{formatMessage(messages.item10)}</span>
            </li>
          </ul>
        </div>
        <div className={styles.imageGrid}>
          <div className={styles.imageLarge}>{imageLarge}</div>
          <div className={styles.imagesSmallWrapper}>
            <div className={styles.imageSmall}>{imageSmall1}</div>
            <div className={styles.imageSmall}>{imageSmall2}</div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(fcseSpirit)
